export const options = [
  {label: 'Masculino', value: "M" },
  {label: 'Feminino', value: "F" }
];